import { Typography, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Content from '../components/Layout/Content';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import NotFound from '../components/NotFound/NotFoundPage';
import Idcard from '../assests/Idcard.svg';
import downloadicon from '../assests/downloadicon.svg';
import { PLAN_COVERAGE } from '../shared/constants';
import { ACTIVE_PLAN_COVERAGE } from '../services/PlanCoverageQueries/PlanCoverageService';
import { useSnackbar } from 'notistack';
import { useQuery } from '@apollo/client';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import { plancoverageArrayConvertor } from '../shared/helper';
import { DEFAULT_NULL_REPLACEMENT } from '../shared/constants';
import {
  PLAN__COVERAGE,
  PLAN_COVERAGE_BREADCRUMBDATA as breadcrumbData,
  IMAGE_ALTERNATE_TEXT,
} from '../shared/Strings';

export const PlanCoverage = () => {
  const [planCoverageData, setPlanCoverageData] = useState([]);
  const [hover, setHover] = useState(false);
  const [datamodal, setDataModal] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const onHover = () => {
    setHover(!hover);
  };

  const planCoverage = () => {
    // eslint-disable-next-line array-callback-return
    const planData = planCoverageData?.map(data => {
      return {
        PlanName: data.planName,
        allfield: [
          { label: 'Primary Insured', value: data.primaryInsure },
          { label: 'Policy Number', value: data.policyNumber },
          { label: 'Start Date', value: data.startDate },
          { label: 'End Date', value: data.endDate },
        ],
      };
    });
    setDataModal(planData);
  };

  useEffect(() => {
    planCoverage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planCoverageData]);

  const getActiveCoverages = useQuery(ACTIVE_PLAN_COVERAGE, {
    variables: {
      offset: 0,
      count: '10',
      sourceUrl: '',
    },
    onError: err => {
      enqueueSnackbar(PLAN__COVERAGE.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
        variant: 'error',
      });
    },
  });

  const loading = getActiveCoverages.loading;

  useEffect(() => {
    if (getActiveCoverages.data) {
      const result = getActiveCoverages.data.getActiveCoverages.coverageList;
      let parser = JSON.parse(result);
      let data = plancoverageArrayConvertor(parser);
      setPlanCoverageData(data);
    }
  }, [getActiveCoverages.data]);

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{PLAN__COVERAGE.TITLE_TEXT}</Typography>
      <Typography variant="h4" sx={{ mt: '36px' }}>
        {PLAN_COVERAGE.TITLE}
      </Typography>
      {!planCoverageData.length ? (
        <NotFound title={PLAN__COVERAGE.TITLE_TEXT} />
      ) : (
        <Box>
          {datamodal.map((obj, index) => (
            <Box
              key={index}
              sx={{
                mt: '24px',
                bgcolor: '#fff',
                maxWidth: '100%',
                maxHeight: '100%',
                borderRadius: '16px',
                p: 3,
              }}>
              <Box key={index}>
                <Typography variant="nav" sx={{ pt: '24px' }}>
                  {obj.PlanName || DEFAULT_NULL_REPLACEMENT}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  alignItems: 'space-between',
                }}>
                <Box
                  onMouseEnter={onHover}
                  onMouseLeave={onHover}
                  sx={{ m: 3, ml: 0, mr: '71px' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      width: '205px',
                      height: '128px',
                      filter: hover ? 'brightness(0.4)' : null,
                    }}>
                    <img src={Idcard} alt={IMAGE_ALTERNATE_TEXT.ID_CARD} />
                  </Box>

                  {hover && (
                    <Box
                      sx={{
                        position: 'absolute',
                        width: '32px',
                        height: '32px',
                        zIndex: 999,
                        mt: '-120px',
                        ml: '157px',
                        '&:hover': {
                          bgcolor: 'red',
                          opacity: 0.5,
                          cursor: 'pointer',
                          transition: 'all forword',
                          transitionDelay: '5s',
                        },
                      }}>
                      <a href={Idcard} download="idCard.svg">
                        <img
                          src={downloadicon}
                          alt={PLAN__COVERAGE.DOWNLOAD_ICON}
                        />
                      </a>
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    mt: '20px',
                    flexFlow: 'wrap',
                    justifyContent: 'space-between',
                  }}>
                  {obj.allfield.map((data, index) => (
                    <Box
                      item
                      key={index}
                      component="span"
                      sx={{ minWidth: '40%' }}>
                      <Typography variant="body1" sx={{ color: '#828282' }}>
                        {data.label}
                      </Typography>
                      <Typography variant="h5">{data.value}</Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      )}
      <SimpleBackdrop open={loading} />
    </Content>
  );
};
